import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

function ModalCalendarEvent({ modalTitle, children, handleIsOpenModal, handleToggleModal }) {
  return (
    <>
      <Modal centered isOpen={handleIsOpenModal} toggle={handleToggleModal}>
        <ModalHeader toggle={handleToggleModal}>{modalTitle}</ModalHeader>
        <ModalBody>{children}</ModalBody>
      </Modal>
    </>
  );
}

export default ModalCalendarEvent;
